<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-10 col-md-8 col-lg-8 mx-auto my-3 Blurb" :class="{ 'is-blurred': menuIsOpen }">
        <h2>Explore the Wolf</h2>
        <p class="Blurb-body">{{ wolfContent.intro }}</p>
        <p class="Blurb-blockquote mt-3 text-center">Click below to explore the wolf, one of earth’s most intelligent and capable top predators.</p>
      </div>
    </div>

    <div class="row">
      <div 
        class="col mt-3 mb-5 ImageMap-container" 
        @mouseover="pingHidden = false" 
        @mouseout="pingHidden = true"  
        :class="{ 'is-blurred': menuIsOpen }">
        <svg
          class="ImageMap ImageMap--ie" version="1.1" 
          xmlns="http://www.w3.org/2000/svg" 
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px" y="0px" 
          viewBox="0 0 2377 1394" 
          style="enable-background:new 0 0 2377 1394;" 
          xml:space="preserve">
          <g id="base">
            <g id="Layer_1_1_">
              <image style="overflow:visible;enable-background:new;" width="1100" height="645" xlink:href="./../../../static/images/explore/wolf-explore--1110.jpg"
                transform="matrix(2.161 0 0 2.161 0.121 3.083901e-02)">
              </image>
            </g>
          </g>

          <g id="Hotspot Hotspot--wolfmaps">
            <rect 
              id="ears-Hotspot Hotspot--wolfmap" 
              x="1916.5" y="221.3" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-ears')"
              @mouseover="detailHandler('wolf-ears', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"
            />
            <rect 
              id="tracks-Hotspot Hotspot--wolfmap" 
              x="282.1" y="514.4" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-tracks')" 
              @mouseover="detailHandler('wolf-tracks', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
            <rect 
              id="title-Hotspot Hotspot--wolfmap" 
              x="444.5" y="146.4" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-size')" 
              @mouseover="detailHandler('wolf-size', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
            <rect 
              id="speed-Hotspot Hotspot--wolfmap" 
              x="1171.5" y="206.3" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-speed')" 
              @mouseover="detailHandler('wolf-speed', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
            <rect 
              id="skull-Hotspot Hotspot--wolfmap" 
              x="1552.5" y="45.3"
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-skull')"
              @mouseover="detailHandler('wolf-skull', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
            <rect 
              id="pup-Hotspot Hotspot--wolfmap" 
              x="1231.3" y="987.4" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-pup')" 
              @mouseover="detailHandler('wolf-pup', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
            <rect 
              id="pack-Hotspot Hotspot--wolfmap" 
              x="704.5" y="36.3" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-pack')" 
              @mouseover="detailHandler('wolf-pack', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
            <rect 
              id="nose-Hotspot Hotspot--wolfmap" 
              x="1814.5" y="458.8" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-nose')" 
              @mouseover="detailHandler('wolf-nose', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
            <rect 
              id="learning-Hotspot Hotspot--wolfmap" 
              x="555.1" y="1021.4" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-learning')" 
              @mouseover="detailHandler('wolf-learning', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
            <rect 
              id="hunt-Hotspot Hotspot--wolfmap" 
              x="2203.3" y="1005.1" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-hunt')" 
              @mouseover="detailHandler('wolf-hunt', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
            <rect 
              id="fur-Hotspot Hotspot--wolfmap" 
              x="644.6" y="294.7" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-fur')" 
              @mouseover="detailHandler('wolf-fur', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
            <rect 
              id="eyes-Hotspot Hotspot--wolfmap" 
              x="2189.5" y="486.3" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-eyes')" 
              @mouseover="detailHandler('wolf-eyes', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
            <rect 
              id="chest-Hotspot Hotspot--wolfmap" 
              x="1135.3" y="637.1" 
              class="st3" 
              width="119.7" height="119.7"
              @click="updateState('wolf-chest')" 
              @mouseover="detailHandler('wolf-chest', 'mouseover')"
              @mouseout="detailHandler(null, 'mouseout')"/>
          </g>
        </svg>

        <!-- ears -->
        <span 
          class=" Hotspot Hotspot--ears Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 25%; left: 75%;" 
          v-if="detail.name === 'wolf-ears'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Ears</h3>
          <p class="Tooltip-subtitle">Explore the ears of the wolf</p>
        </div>

        <!-- chest -->
        <span 
          class=" Hotspot Hotspot--chest Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 52%; left: 51%;" 
          v-if="detail.name === 'wolf-chest'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Chest</h3>
          <p class="Tooltip-subtitle">Explore the chest of the wolf</p>
        </div>

        <!-- eyes -->
        <span 
          class=" Hotspot Hotspot--eyes Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 43%; left: 80%;" 
          v-if="detail.name === 'wolf-eyes'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Eyes</h3>
          <p class="Tooltip-subtitle">Explore the eyes of the wolf</p>
        </div>

        <!-- fur -->
        <span 
          class=" Hotspot Hotspot--fur Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 29%; left: 29%;" 
          v-if="detail.name === 'wolf-fur'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Fur</h3>
          <p class="Tooltip-subtitle">Explore the coat of the wolf</p>
        </div>

        <!-- hunt -->
        <span 
          class=" Hotspot Hotspot--hunt Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 79%; left: 78%;" 
          v-if="detail.name === 'wolf-hunt'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Hunting</h3>
          <p class="Tooltip-subtitle">Explore wolves on the hunt</p>
        </div>

        <!-- learning -->
        <span 
          class=" Hotspot Hotspot--learning Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 82%; left: 22%;" 
          v-if="detail.name === 'wolf-learning'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Learning</h3>
          <p class="Tooltip-subtitle">Explore how young wolves learn from adults</p>
        </div>

        <!-- nose -->
        <span 
          class=" Hotspot Hotspot--nose Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 41%; left: 77%;" 
          v-if="detail.name === 'wolf-nose'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Nose</h3>
          <p class="Tooltip-subtitle">Explore the nose of the wolf</p>
        </div>

        <!-- pack -->
        <span 
          class=" Hotspot Hotspot--pack Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 11%; left: 31%;" 
          v-if="detail.name === 'wolf-pack'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Pack</h3>
          <p class="Tooltip-subtitle">Explore the size of a pack</p>
        </div>

        <!-- pup -->
        <span 
          class=" Hotspot Hotspot--pup Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 78%; left: 52%;" 
          v-if="detail.name === 'wolf-pup'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Pups</h3>
          <p class="Tooltip-subtitle">Explore the lives of wolf pups</p>
        </div>

        <!-- skull -->
        <span 
          class=" Hotspot Hotspot--skull Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 11%; left: 65%;" 
          v-if="detail.name === 'wolf-skull'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Skull</h3>
          <p class="Tooltip-subtitle">Explore the cranial structure of the wolf</p>
        </div>

        <!-- speed -->
        <span 
          class=" Hotspot Hotspot--speed Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 23%; left: 50%;" 
          v-if="detail.name === 'wolf-speed'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Speed</h3>
          <p class="Tooltip-subtitle">Explore the speed of the wolf</p>
        </div>

        <!-- title -->
        <span 
          class=" Hotspot Hotspot--title Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 18%; left: 20%;" 
          v-if="detail.name === 'wolf-size'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Size</h3>
          <p class="Tooltip-subtitle">Explore the size of the wolf</p>
        </div>

        <!-- tracks -->
        <span 
          class=" Hotspot Hotspot--tracks Hotspot--wolfmap ping--continuous"
          :class="{ 'is-hidden': pingHidden }">
        </span>
        <div 
          class="Tooltip Tooltip--wolfMap" 
          style="top: 45%; left: 12%;" 
          v-if="detail.name === 'wolf-tracks'" 
          :class="{ 'is-shown': !pingHidden }">
          <h3 class="Tooltip-title">Tracks</h3>
          <p class="Tooltip-subtitle">Explore wolf tracks</p>
        </div>

      </div>
    </div>

    <div class="row Contents">

      <transition name="fade">
        <div class="col-md-4 mx-auto Contents-container" v-if="menuIsOpen">
          <ol class="Contents-menu" v-on-clickaway="closeMenu">
            <li 
              class="Contents-menu-item"
              v-for="(detail, i) in wolfContent.mapDetail" 
              :key="i" 
              @click="updateState(detail.name)">
              {{ detail.title }}
            </li>
          </ol>
        </div>
      </transition>

      <div class="col-12 mx-auto">
        <button class="Button Button--transparent mx-auto mb-5" @click="menuIsOpen = !menuIsOpen">
          {{ (menuIsOpen) ? 'Hide Contents' : 'Show Contents' }}
        </button>
      </div>
    </div>

  </div>
</template>

<script>
const _ = require('lodash')
import { mixin as clickaway } from 'vue-clickaway'
export default {
  mixins: [ clickaway ],

  data () {
    return {
      detail: {
        title: ''
      },
      instruction: 'Explore the wolf',
      menuIsOpen: false,
      pingHidden: null
    }
  },

  computed: {
    tooltip () {
      return document.getElementsByClassName('Tooltip')
    },

    wolfContent () {
      return this.$store.getters.wolfContent
    }
  },

  methods: {
    closeMenu () {
      this.menuIsOpen = false
    },

    detailHandler (selection, mouseState) {
      if (mouseState === 'mouseover' && !this.menuIsOpen) {
        this.detail = this.getDetail(selection)
      } else if (mouseState === 'mouseout') {
        this.resetDetail()
      }
    },

    getDetail (selection) {
      return _.find(this.wolfContent.mapDetail, { name: selection })
    },

    resetDetail () {
      this.detail = { title: '' }
    },

    updateState (selection) {
      let detailObj = this.getDetail(selection)
      let payload = {
        parent: 'wolfmap',
        updates: {
          currentDetail: detailObj,
          currentView: 'appWolfDetail',
          animation: 'slideUp'
        }
      }
      this.$store.dispatch('updateProps', payload)
    }
  },

  created () {
    if (this.$route.query.id) {
      setTimeout(() => {
        this.updateState(this.$route.query.id)
      }, 1000)
    }
  },

  mounted () {
    setTimeout(() => {
      if (this.pingHidden === null) {
        this.pingHidden = true
      }
    }, 1000 * 10)
  }
}
</script>

<style lang="scss" scoped>
@import './../../assets/_variables.scss';
@import './../../assets/_image-map.scss';
@import './../../assets/_toc.scss';

.st3 {
  cursor: pointer;
  fill: transparent;
}

.Hotspot--ears {
  top: 17%;
  left: 79%;  
  @media screen and (min-width: $grid-lg) {
    top: 19%;
    left: 81.45%;
  }
}

.Hotspot--tracks {
  top: 37%;
  left: 16%;
  @media screen and (min-width: $grid-lg) {
    top: 39%;
    left: 14.5%;
  }
}

.Hotspot--title {
  top: 12%;
  left: 22%;
  @media screen and (min-width: $grid-lg) {
    top: 13%;
    left: 21%;
  }
}

.Hotspot--speed {
  top: 16%;
  left: 50%;
  @media screen and (min-width: $grid-lg) {
    top: 17.3%;
    left: 50.9%;
  }
}

.Hotspot--skull {
  top: 5%;
  left: 65%;
  @media screen and (min-width: $grid-lg) {
    top: 5.85%;
    left: 66.5%;
  }
}

.Hotspot--pup {
  top: 71%;
  left: 52.5%;
  @media screen and (min-width: $grid-lg) {
    top: 73%;
    left: 53.35%;
  }
}

.Hotspot--pack {
  top: 4.5%;
  left: 32%;
  @media screen and (min-width: $grid-lg) {
    top: 5%;
    left: 31.85%;
  }
}

.Hotspot--nose {
  top: 33.5%;
  left: 75.5%;
  @media screen and (min-width: $grid-lg) {
    top: 35.5%;
    left: 77.3%;
  }
}

.Hotspot--learning {
  top: 73%;
  left: 26.5%;
  @media screen and (min-width: $grid-lg) {
    top: 75.5%;
    left: 25.65%;
  }
}

.Hotspot--hunt {
  top: 72%;
  left: 90%;
  @media screen and (min-width: $grid-lg) {
    top: 74.3%;
    left: 93.1%;
  }
}

.Hotspot--fur {
  top: 22%;
  left: 30%;
  @media screen and (min-width: $grid-lg) {
    top: 23.75%;
    left: 29.4%;
  }
}

.Hotspot--eyes {
  top: 35%;
  left: 89.5%;
  @media screen and (min-width: $grid-md) {
    top: 35.5%;
    left: 91%;
  }
  @media screen and (min-width: $grid-lg) {
    top: 37.25%;
    left: 92.55%;
  }
}

.Hotspot--chest {
  top: 46%;
  left: 49%;
  @media screen and (min-width: $grid-lg) {
    top: 48%;
    left: 49.45%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/explore/wolf-map.vue